/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as UpdatesImport } from './routes/updates'
import { Route as OfflineStatusImport } from './routes/offline-status'
import { Route as IndexImport } from './routes/index'
import { Route as UpdatesRegionsImport } from './routes/updates.regions'
import { Route as OfflineStatusRegionsImport } from './routes/offline-status.regions'
import { Route as UpdatesRegionsIndexImport } from './routes/updates.regions.index'
import { Route as OfflineStatusRegionsIndexImport } from './routes/offline-status.regions.index'
import { Route as UpdatesRegionsRegionIdImport } from './routes/updates.regions.$regionId'
import { Route as OfflineStatusRegionsRegionIdImport } from './routes/offline-status.regions.$regionId'
import { Route as UpdatesRegionsRegionIdLocalitiesImport } from './routes/updates.regions.$regionId_.localities'
import { Route as OfflineStatusRegionsRegionIdLocalitiesImport } from './routes/offline-status.regions.$regionId_.localities'
import { Route as UpdatesRegionsRegionIdLocalitiesLocalityIdImport } from './routes/updates.regions.$regionId_.localities.$localityId'
import { Route as OfflineStatusRegionsRegionIdLocalitiesLocalityIdImport } from './routes/offline-status.regions.$regionId_.localities.$localityId'
import { Route as UpdatesRegionsRegionIdLocalitiesLocalityIdLocationsImport } from './routes/updates.regions.$regionId_.localities.$localityId_.locations'
import { Route as OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsImport } from './routes/offline-status.regions.$regionId_.localities.$localityId_.locations'
import { Route as UpdatesRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdImport } from './routes/updates.regions.$regionId_.localities.$localityId_.locations.$locationId'
import { Route as OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdImport } from './routes/offline-status.regions.$regionId_.localities.$localityId_.locations.$locationId'

// Create/Update Routes

const UpdatesRoute = UpdatesImport.update({
  path: '/updates',
  getParentRoute: () => rootRoute,
} as any)

const OfflineStatusRoute = OfflineStatusImport.update({
  path: '/offline-status',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const UpdatesRegionsRoute = UpdatesRegionsImport.update({
  path: '/regions',
  getParentRoute: () => UpdatesRoute,
} as any)

const OfflineStatusRegionsRoute = OfflineStatusRegionsImport.update({
  path: '/regions',
  getParentRoute: () => OfflineStatusRoute,
} as any)

const UpdatesRegionsIndexRoute = UpdatesRegionsIndexImport.update({
  path: '/',
  getParentRoute: () => UpdatesRegionsRoute,
} as any)

const OfflineStatusRegionsIndexRoute = OfflineStatusRegionsIndexImport.update({
  path: '/',
  getParentRoute: () => OfflineStatusRegionsRoute,
} as any)

const UpdatesRegionsRegionIdRoute = UpdatesRegionsRegionIdImport.update({
  path: '/$regionId',
  getParentRoute: () => UpdatesRegionsRoute,
} as any)

const OfflineStatusRegionsRegionIdRoute =
  OfflineStatusRegionsRegionIdImport.update({
    path: '/$regionId',
    getParentRoute: () => OfflineStatusRegionsRoute,
  } as any)

const UpdatesRegionsRegionIdLocalitiesRoute =
  UpdatesRegionsRegionIdLocalitiesImport.update({
    path: '/$regionId/localities',
    getParentRoute: () => UpdatesRegionsRoute,
  } as any)

const OfflineStatusRegionsRegionIdLocalitiesRoute =
  OfflineStatusRegionsRegionIdLocalitiesImport.update({
    path: '/$regionId/localities',
    getParentRoute: () => OfflineStatusRegionsRoute,
  } as any)

const UpdatesRegionsRegionIdLocalitiesLocalityIdRoute =
  UpdatesRegionsRegionIdLocalitiesLocalityIdImport.update({
    path: '/$localityId',
    getParentRoute: () => UpdatesRegionsRegionIdLocalitiesRoute,
  } as any)

const OfflineStatusRegionsRegionIdLocalitiesLocalityIdRoute =
  OfflineStatusRegionsRegionIdLocalitiesLocalityIdImport.update({
    path: '/$localityId',
    getParentRoute: () => OfflineStatusRegionsRegionIdLocalitiesRoute,
  } as any)

const UpdatesRegionsRegionIdLocalitiesLocalityIdLocationsRoute =
  UpdatesRegionsRegionIdLocalitiesLocalityIdLocationsImport.update({
    path: '/$localityId/locations',
    getParentRoute: () => UpdatesRegionsRegionIdLocalitiesRoute,
  } as any)

const OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsRoute =
  OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsImport.update({
    path: '/$localityId/locations',
    getParentRoute: () => OfflineStatusRegionsRegionIdLocalitiesRoute,
  } as any)

const UpdatesRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdRoute =
  UpdatesRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdImport.update({
    path: '/$locationId',
    getParentRoute: () =>
      UpdatesRegionsRegionIdLocalitiesLocalityIdLocationsRoute,
  } as any)

const OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdRoute =
  OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdImport.update(
    {
      path: '/$locationId',
      getParentRoute: () =>
        OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/offline-status': {
      preLoaderRoute: typeof OfflineStatusImport
      parentRoute: typeof rootRoute
    }
    '/updates': {
      preLoaderRoute: typeof UpdatesImport
      parentRoute: typeof rootRoute
    }
    '/offline-status/regions': {
      preLoaderRoute: typeof OfflineStatusRegionsImport
      parentRoute: typeof OfflineStatusImport
    }
    '/updates/regions': {
      preLoaderRoute: typeof UpdatesRegionsImport
      parentRoute: typeof UpdatesImport
    }
    '/offline-status/regions/$regionId': {
      preLoaderRoute: typeof OfflineStatusRegionsRegionIdImport
      parentRoute: typeof OfflineStatusRegionsImport
    }
    '/updates/regions/$regionId': {
      preLoaderRoute: typeof UpdatesRegionsRegionIdImport
      parentRoute: typeof UpdatesRegionsImport
    }
    '/offline-status/regions/': {
      preLoaderRoute: typeof OfflineStatusRegionsIndexImport
      parentRoute: typeof OfflineStatusRegionsImport
    }
    '/updates/regions/': {
      preLoaderRoute: typeof UpdatesRegionsIndexImport
      parentRoute: typeof UpdatesRegionsImport
    }
    '/offline-status/regions/$regionId/localities': {
      preLoaderRoute: typeof OfflineStatusRegionsRegionIdLocalitiesImport
      parentRoute: typeof OfflineStatusRegionsImport
    }
    '/updates/regions/$regionId/localities': {
      preLoaderRoute: typeof UpdatesRegionsRegionIdLocalitiesImport
      parentRoute: typeof UpdatesRegionsImport
    }
    '/offline-status/regions/$regionId/localities/$localityId': {
      preLoaderRoute: typeof OfflineStatusRegionsRegionIdLocalitiesLocalityIdImport
      parentRoute: typeof OfflineStatusRegionsRegionIdLocalitiesImport
    }
    '/updates/regions/$regionId/localities/$localityId': {
      preLoaderRoute: typeof UpdatesRegionsRegionIdLocalitiesLocalityIdImport
      parentRoute: typeof UpdatesRegionsRegionIdLocalitiesImport
    }
    '/offline-status/regions/$regionId/localities/$localityId/locations': {
      preLoaderRoute: typeof OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsImport
      parentRoute: typeof OfflineStatusRegionsRegionIdLocalitiesImport
    }
    '/updates/regions/$regionId/localities/$localityId/locations': {
      preLoaderRoute: typeof UpdatesRegionsRegionIdLocalitiesLocalityIdLocationsImport
      parentRoute: typeof UpdatesRegionsRegionIdLocalitiesImport
    }
    '/offline-status/regions/$regionId/localities/$localityId/locations/$locationId': {
      preLoaderRoute: typeof OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdImport
      parentRoute: typeof OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsImport
    }
    '/updates/regions/$regionId/localities/$localityId/locations/$locationId': {
      preLoaderRoute: typeof UpdatesRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdImport
      parentRoute: typeof UpdatesRegionsRegionIdLocalitiesLocalityIdLocationsImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  OfflineStatusRoute.addChildren([
    OfflineStatusRegionsRoute.addChildren([
      OfflineStatusRegionsRegionIdRoute,
      OfflineStatusRegionsIndexRoute,
      OfflineStatusRegionsRegionIdLocalitiesRoute.addChildren([
        OfflineStatusRegionsRegionIdLocalitiesLocalityIdRoute,
        OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsRoute.addChildren(
          [
            OfflineStatusRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdRoute,
          ],
        ),
      ]),
    ]),
  ]),
  UpdatesRoute.addChildren([
    UpdatesRegionsRoute.addChildren([
      UpdatesRegionsRegionIdRoute,
      UpdatesRegionsIndexRoute,
      UpdatesRegionsRegionIdLocalitiesRoute.addChildren([
        UpdatesRegionsRegionIdLocalitiesLocalityIdRoute,
        UpdatesRegionsRegionIdLocalitiesLocalityIdLocationsRoute.addChildren([
          UpdatesRegionsRegionIdLocalitiesLocalityIdLocationsLocationIdRoute,
        ]),
      ]),
    ]),
  ]),
])

/* prettier-ignore-end */
